import { getEnvRuntimeVariable } from '@if/core/utils'
import { getUserToken } from '@src/shared/providers/UserProvider'
import axios, { AxiosError } from 'axios'

const instance = axios.create({
  baseURL: getEnvRuntimeVariable(import.meta.env.VITE_APP_API_URL),
})

let interceptorInitialized = false

export function initApiClient(reportApiError: (error: AxiosError) => void) {
  if (interceptorInitialized) return
  interceptorInitialized = true

  // Request interceptor: always use fresh token
  instance.interceptors.request.use((config) => {
    const token = getUserToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })

  // Response interceptor: handle errors and 401
  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('jwtToken')
        window.location.href = '/login'
        return Promise.reject(error)
      }

      if (reportApiError) reportApiError(error)
      return Promise.reject(error)
    },
  )
}

export function getApiClient() {
  return instance
}

export { instance as apiClient }
